module.exports = __webpack_public_path__ + "img/card_jean_background.b3e01fa2.png";